import axios from 'axios';

import { getEnv, getCsrfToken } from '@ctct/ctct-helpers';

const instance = axios.create({
  baseURL: `https://apps${getEnv()}constantcontact.com`,
  headers: {
    'X-CSRF-Token': getCsrfToken(),
  },
});

instance.interceptors.request.use(
  (config) => {
    const csrf = getCsrfToken();

    // Do something before request is sent
    // eslint-disable-next-line no-param-reassign
    config.headers['X-CSRF-Token'] = csrf === 'local' ? '' : csrf;

    const { hostname } = new URL(config.url);

    if (hostname.includes('constantcontact.com')) {
      // eslint-disable-next-line no-param-reassign
      config.withCredentials = true;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
